module.exports = __webpack_public_path__ + "img/vertical_3_5_7005.80654afd.png";